export default "__VITE_ASSET__CbEUGR_N__"